import React from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import { TableCell, TableRow } from '@mui/material';
import { useTranslation } from 'react-i18next';
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded';
import verificationStatusIds from 'constants/verificationStatusIds';
import { getVerificationTypes } from '../../../selectors';
import { getVerificationDocumentDetails } from '../../../common/functions';
import { SelectedForManualInterrogationWrapper } from '../../../VerificationStyles';

const SelectVerificationsItemComponent = ({ item, selectVerificationForReinterogation }) => {
  const [t] = useTranslation();

  const verificationTypes = useSelector(state => getVerificationTypes(state), shallowEqual);

  const isVerificationActive = (verificationTypes, verificationName) =>
    verificationTypes.some(vt => vt.verificationName === verificationName);

  const getSelectionLabel = verification => {
    if (!isVerificationActive(verificationTypes, verification.verificationType)) return t('Tooltips.VerificationIsNotActive');
    else if (item.statusId === verificationStatusIds.InProcess) return t('Tooltips.VerificationIsInProcess');
    else
      return !item.isSelected ? t('Tooltips.SelectVerificationForReinterrogation') : t('Tooltips.DeselectVerificationFromReinterrogation');
  };

  return (
    <TableRow key={item.verificationId}>
      <TableCell>{item.verificationType}</TableCell>
      <TableCell>{`${item.partnerName} ${getVerificationDocumentDetails(item)}`}</TableCell>
      <TableCell>{t('DATE', { date: item.date })}</TableCell>
      <TableCell>{item.status}</TableCell>
      <TableCell>{t('DATE', { date: item.validityDate })}</TableCell>
      <TableCell>
        <SelectedForManualInterrogationWrapper
          isSelected={item.isSelected}
          onClick={selectVerificationForReinterogation}
          disabled={item.statusId === verificationStatusIds.InProcess || !isVerificationActive(verificationTypes, item.verificationType)}
          tooltip={getSelectionLabel(item)}
          color={'transparent'}
        >
          <GetAppRoundedIcon />
        </SelectedForManualInterrogationWrapper>
      </TableCell>
    </TableRow>
  );
};

SelectVerificationsItemComponent.propTypes = {
  verifications: PropTypes.array,
  selectVerificationForReinterogation: PropTypes.func.isRequired,
  item: PropTypes.object
};

export default SelectVerificationsItemComponent;
